import { authedFetch } from '@/lib/api-client'

// Wire format de la API (ver /specs/docente-fichas.md "Admin - gestion de
// docentes"). Solo ADMIN. Baja/alta reversible (suspension, NO soft-delete).

export type DocenteStatusFilter = 'active' | 'suspended' | 'all'

export interface Docente {
  id: string
  nombre: string
  apellido: string
  email: string
  username: string | null
  createdAt: string
  /** ISO date si esta suspendido; null si activo. */
  suspendedAt: string | null
  /** Permiso para publicar fichas de referencia (lo otorga/revoca el ADMIN). */
  canPublishFichas: boolean
}

interface DocenteListResponse {
  items: Docente[]
}

// Alta de docente. email/password crean la cuenta en Firebase Auth.
export interface CreateDocenteInput {
  nombre: string
  apellido: string
  email: string
  password: string
  canPublishFichas: boolean
}

// Edicion. Todos los campos opcionales; password vacio no cambia la contrasena.
export interface UpdateDocenteInput {
  nombre?: string
  apellido?: string
  email?: string
  password?: string
  canPublishFichas?: boolean
}

export async function listDocentes(
  status: DocenteStatusFilter = 'all',
): Promise<Docente[]> {
  const search = new URLSearchParams()
  search.set('status', status)
  // La API envuelve las listas en `{ items }` (igual que noticias/usuarios).
  const res = await authedFetch<DocenteListResponse>(
    `/admin/docentes?${search.toString()}`,
    { method: 'GET' },
  )
  return res.items
}

export async function createDocente(input: CreateDocenteInput): Promise<Docente> {
  return authedFetch<Docente>('/admin/docentes', { method: 'POST', body: input })
}

export async function updateDocente(
  id: string,
  input: UpdateDocenteInput,
): Promise<Docente> {
  return authedFetch<Docente>(`/admin/docentes/${id}`, { method: 'PATCH', body: input })
}

export async function suspendDocente(id: string): Promise<Docente> {
  return authedFetch<Docente>(`/admin/users/${id}/suspend`, { method: 'POST' })
}

export async function reactivateDocente(id: string): Promise<Docente> {
  return authedFetch<Docente>(`/admin/users/${id}/reactivate`, {
    method: 'POST',
  })
}
